import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { getUserDetails } from "../utils/userDetailsUtils";

const removeProcessingTC = async ({ tcid, condition }) => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=removeProcessingTC&companyId=${user.companyid}&tcid=${tcid}&condition=${condition}`,
  );

  return response;
};

const useRemoveProcessingTCQuery = (options = {}) => {
  return useMutation({
    mutationFn: removeProcessingTC,
    ...options,
  });
};

export default useRemoveProcessingTCQuery;
